import { useTranslation } from 'react-i18next';

import { usePackingListStore } from 'stores/packingList/packingList';
import { translationForDocumentTypeWithVirtual } from 'support/helpers/transactions/transactions';
import { Popup } from 'components/Display/Popup/Popup';
import { Button } from 'components/Form/Button/Button';

type UnplacedItemsWarningDialogProps = {
  onConfirm: () => void;
  onCancel: () => void;
};

export const UnplacedItemsWarningDialog = ({ onConfirm, onCancel }: UnplacedItemsWarningDialogProps) => {
  const { t } = useTranslation();
  const documentType = usePackingListStore((state) => state.documentType);
  const documentTypeLabel = translationForDocumentTypeWithVirtual(t, documentType);
  return (
    <Popup
      open
      onClose={onCancel}
      title={t('webedi:packing_list.unplaced_warning.title')}
      subtitle={t('webedi:packing_list.unplaced_warning.body', { documentType: documentTypeLabel })}
      testId="packing-list-unplaced-warning"
      CancelButton={({ cancelButtonRef }) => (
        <Button
          variant="secondary"
          ref={cancelButtonRef}
          onClick={onCancel}
          analyticsId="webedi:packing_list_keep_editing"
        >
          {t('webedi:packing_list.unplaced_warning.keep_editing')}
        </Button>
      )}
      PrimaryButton={() => (
        <Button onClick={onConfirm} analyticsId="webedi:packing_list_apply_anyway">
          {t('webedi:packing_list.unplaced_warning.confirm')}
        </Button>
      )}
    />
  );
};
